<template>
	<div class="d-flex justify-content-between">
		<div class="d-flex">
			<div>
				<avatar :user="userMember.user" />
			</div>
			<div class="pl-2">
				<div class="text--darken-2 grey--text font-weight-bold">
					{{ userMember.user.name }}
					<v-icon
						v-if="userMember.role === 'owner' || userMember.role === 'moderator'"
						style="margin-top: -3px"
					>$admin-star</v-icon>
				</div>
				<div class="font-12 grey--text mt-1">Team</div>
			</div>
		</div>
		<div class="d-flex align-center" v-if="allowToEdit">
			<template v-if="editable">
				<v-select
					v-model="role"
					:disabled="role === 'owner' || sending"
					hide-details
					:items="options"
					outlined
					dense
					class="box-shadow-base font-12 user-member-select mr-2"
					:height="36"
					:menu-props="{ bottom: true, offsetY: true }"
					:item-text="item => item.text"
					:item-value="item => item.value"
					:item-disabled="item => item.disabled"
				></v-select>
				<v-btn
					elevation="0"
					color="red lighten-1"
					class="red--text"
					@click="removeUser()"
					:disabled="role === 'owner' || sending"
				>
					<v-icon class="mr-1">$trash</v-icon>{{ $vuetify.lang.t('$vuetify.views.group.settings.removeFromGroup') }}
				</v-btn>
			</template>
			<template v-if="request">
				<v-btn
					elevation="0"
					color="accent lighten-1"
					class="accent--text mr-2"
					@click="acceptRejectGroup({ id: group.id, status: 'accepted', user_id: userMember.user.id })"
				>
					Zaakceptuj
				</v-btn>
				<v-btn
					elevation="0"
					color="red lighten-1"
					class="red--text"
					@click="acceptRejectGroup({ id: group.id, status: 'rejected', user_id: userMember.user.id })"
				>
					Anuluj
				</v-btn>
			</template>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Avatar from "@/components/Avatar";
export default {
	name: "GroupFormMember",
	components: {
		Avatar
	},
	props: {
		userMember: {
			type: Object,
			required: true
		},
		editable: {
			type: Boolean,
			default: false
		},
		request: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			role: null,
			sending: false,
			options: [
				{
					value: 'owner',
					text: 'Właściciel',
					disabled: true
				},
				{
					value: 'moderator',
					text: 'Administrator',
				},
				{
					value: 'member',
					text: 'Członek',
				},
			]
		}
	},
	computed: {
		...mapGetters({
			group: "groups/group",
			user: "auth/user",
		}),
		allowToEdit: function () {
			return this.group.admins.findIndex(item => item.id === this.user.id) > -1
		}
	},
	created() {
		this.role = this.userMember.role
		this.$watch('role', async function (v) {
			this.sending = true
			await this.changeGroupUserRole({
				id: this.group.id,
				params: {
					user_id: this.userMember.user.id,
					role: v
				}
			})
			this.$snackbar.success("Rola została zmieniona!")
			this.sending = false
		})
	},
	methods: {
		...mapActions('groups', [
			'removeGroupUser',
			'changeGroupUserRole',
			'acceptRejectGroup',
		]),
		async removeUser() {
			this.sending = true
			await this.removeGroupUser({
				group_id: this.group.id,
				user_id: this.userMember.user.id
			})
			this.$snackbar.success("Użytkownik został usunięty z grupy!")
			this.sending = false
		}
	}
}
</script>

<style lang="scss">
.user-member-select {
	width: 150px;
	.v-input__slot {
		min-height: unset !important;
	}
}
</style>
